module.exports = __webpack_public_path__ + "static/media/logo.dcf5f7a7.png";